<template>
  <div class="app_menu_container">
    <PageTitle :title="title" backPath="Home" />
    <div class="app_menu_main">
      <PageSearchDataList
        ref="PageSearchDataListRef"
        @toDetail="toDetail"
        :searchData="searchData"
        @loadNextPageData="loadNextPageData"
        :cardOption="cardOption"
      />
    </div>
  </div>
</template>
<script>
import PageTitle from '@/components/app/PageHeader.vue'
import PageSearchDataList from '@/components/app/PageSearchDataList.vue'

export default {
  components: {
    PageTitle,
    PageSearchDataList
  },
  data() {
    return {
      title: '报价',
      searchData: [],
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 10, // 每页10条
        align: 'right',
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      // 卡片配置
      cardOption: {
        path: 'QuotationApply',
        title: '报价',
        mainPersonKey: 'creator',
        mainDateKey: 'requirement_date',
        col: [
          {
            label: '企业名称',
            key: 'customer_name',
            type: 'string'
          },
          {
            label: '项目名称',
            key: 'project_name',
            type: 'string'
          },
          {
            label: '需求概述',
            key: 'requirement_content',
            type: 'string'
          },
          {
            label: '对外报价(元)',
            key: 'outward_quotation',
            type: 'money'
          }
          // {
          //   label: '审批报价(元)',
          //   key: 'final_quotation',
          //   type: 'money'
          // }
        ]
      },
      menuArgs: ''
    }
  },
  mounted() {
    if (this.$route.query?.type && this.$route.query.type === 'todo') {
      this.menuArgs = 'phone'
    } else {
      this.menuArgs = ''
    }

    this.list()
  },
  methods: {
    // 获取数据
    async list() {
      const { data: res } = await this.$http.post('/Finance/Quotation_apply/list', {
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize,
        seeType: 4,
        searchObjects: [],
        menuArgs: this.menuArgs
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.searchData = [...this.searchData, ...res.data.rows]
      this.tablePage.total = res.data.totals
      if (this.searchData.length === this.tablePage.total) {
        this.$refs.PageSearchDataListRef.isLoadAll = true
      }
      this.$refs.PageSearchDataListRef.isLoading = false
    },
    toDetail(item) {
      // 财务不能进入明细
      if (this.$store.state.userInfo.name === '连燕燕') {
        return
      }
      this.$router.push({
        path: '/AppQuotationApplyDetail',
        query: {
          id: item.id,
          menuArgs: this.menuArgs
        }
      })
    },
    // 加载更多
    loadNextPageData() {
      this.tablePage.currentPage++
      this.list()
    }
  }
}
</script>
<style lang="less" scoped>
@headerHeight: 50px;

.app_menu_container {
  width: 100vw;
  height: 100vh;

  .app_menu_main {
    height: calc(100% - @headerHeight);
    width: 100%;
    background-color: #fafafa;
  }
}
</style>
